import React, { useState, useEffect, useRef } from "react";
import {
  MapContainer,
  TileLayer,
  useMapEvents,
  Marker,
  Popup,
  useMap,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import { LineWave } from "react-loader-spinner";
import L from "leaflet";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  AddCollectionPointsDetails,
  UpdateCollectionPointsDetails,
} from "../../Apis/collectionPointsApi";
import {
  GetCirclebyID,
  GetWardsbyCircleId,
} from "../../Apis/organizationApi";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { metronome } from "ldrs";
import { useCollectionPointStore } from "./store/useCollectionPointStore";
import FilePreview from "../AssetVehicle/FilePreview";

function AddCollectionPoint({
  editCollectionDetails,
  edit,
  setLgShow,
  fetchAllCollectionPointDetails,
  setEdit,
  editPermission,
  allZones: parentAllZones,
  collectionPointTypes: parentCollectionPointTypes,
}) {
  // edit && console.log("editCollectionDetails", editCollectionDetails);
  metronome.register();
  const [position, setPosition] = useState({ lat: 17.452555, lng: 78.3599819 });
  const [zoneId, setzoneId] = useState();
  const [circleId, setcircleId] = useState();
  const isEditInitializing = useRef(false);
  const lastEditId = useRef(null);
  // Use props from parent instead of fetching
  const [collectionPointTypes, setCollectionPointTypes] = useState(parentCollectionPointTypes || []);
  const [allZones, setAllZones] = useState(parentAllZones || []);
  const [allCircles, setAllCircles] = useState([]);
  const [allWards, setAllWards] = useState([]);
  const [IsLoading, setISLoading] = useState(false);
  const [CollectionPointTypeName, setCollectionPointTypeName] = useState("");

  //  -------------- circles-----------
  const fetchCirclesAndWards = async (zoneId) => {
    try {
      const circlesData = await GetCirclebyID(zoneId);
      setAllCircles(circlesData);
    } catch (error) { }
  };
  //  ------------ wards--------------------
  const fetchWardsData = async (circleId) => {
    try {
      const response = await GetWardsbyCircleId(circleId);
      setAllWards(response);
      return response;
    } catch (error) {
      console.error("Error fetching wards data:", error);
      throw error;
    }
  };
  // Removed fetchCollectionPointTypes - using data from parent props

  // const {handleFileChange, filePreviews} = useCollectionPointStore();
  const [filePreviews, setFilePreviews] = useState({
    file: null,
    fileType: "",
    fileUrl: "",
  });
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Clear the previous image
      setFilePreviews({ file: null, fileType: "", fileUrl: "" });

      // Set new file after clearing the previous one
      setTimeout(() => {
        const fileUrl = URL.createObjectURL(file);
        const fileType = file.type;
        setFilePreviews({ file, fileType, fileUrl });
      }, 0);
    }
  };



  //------------------- map functionality-----

  useEffect(() => {
    // Use data from parent props instead of fetching
    if (parentAllZones && parentAllZones.length > 0) {
      setAllZones(parentAllZones);
    }
    if (parentCollectionPointTypes && parentCollectionPointTypes.length > 0) {
      setCollectionPointTypes(parentCollectionPointTypes);
    }
    if (edit && editCollectionDetails) {
      const editId = editCollectionDetails.collectionPointId || editCollectionDetails.id;
      // Only initialize if this is a new edit session
      if (lastEditId.current !== editId) {
        lastEditId.current = editId;
        isEditInitializing.current = true;
        setPosition({
          lat: editCollectionDetails?.latitude,
          lng: editCollectionDetails?.longitude,
        });
        // Fetch circles and wards once when entering edit mode
        const editZoneId = editCollectionDetails?.zoneId;
        const editCircleId = editCollectionDetails?.circleId;
        
        if (editZoneId) {
          // Fetch circles first, then wards
          fetchCirclesAndWards(editZoneId)
            .then(() => {
              if (editCircleId) {
                return fetchWardsData(editCircleId);
              }
              return Promise.resolve();
            })
            .then(() => {
              // Set zoneId and circleId after all fetches complete
              // This prevents the useEffects from triggering duplicate API calls
              setzoneId(editZoneId);
              setcircleId(editCircleId);
              // Reset flag after a short delay to ensure state updates are processed
              setTimeout(() => {
                isEditInitializing.current = false;
              }, 50);
            })
            .catch((error) => {
              console.error("Error fetching edit data:", error);
              setzoneId(editZoneId);
              setcircleId(editCircleId);
              isEditInitializing.current = false;
            });
        } else {
          setzoneId(editZoneId);
          setcircleId(editCircleId);
          isEditInitializing.current = false;
        }
      }
    } else if (!edit) {
      // Reset flags when not in edit mode
      isEditInitializing.current = false;
      lastEditId.current = null;
    }
  }, [edit, editCollectionDetails, parentAllZones, parentCollectionPointTypes]);

  useEffect(() => {
    // Only fetch if not initializing edit mode and zoneId is set
    // Also skip if we're in edit mode and circles are already loaded
    if (zoneId && !isEditInitializing.current && !(edit && allCircles.length > 0)) {
      fetchCirclesAndWards(zoneId);
    }
  }, [zoneId, edit, allCircles.length]);

  useEffect(() => {
    // Only fetch if not initializing edit mode and circleId is set
    // Also skip if we're in edit mode and wards are already loaded
    if (circleId && !isEditInitializing.current && !(edit && allWards.length > 0)) {
      fetchWardsData(circleId);
    }
  }, [circleId, edit, allWards.length]);

  const customIcon = new L.Icon({
    iconUrl: "https://cdn-icons-png.flaticon.com/512/1483/1483336.png",
    iconSize: [48, 48],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  const MapEvents = ({ setFieldValue }) => {
    const map = useMap();

    useMapEvents({
      click(e) {
        if (e.latlng) {
          const { lat, lng } = e.latlng;
          setPosition({ lat, lng });
          // Update formik values for Latitude and Longitude
          setFieldValue("Latitude", lat);
          setFieldValue("Longitude", lng);
        }
      },
    });

    return null;
  };

  const submitCollectionPoint = async (formData) => {
    try {
      setISLoading(true);
      const response = edit
        ? await UpdateCollectionPointsDetails(formData)
        : await AddCollectionPointsDetails(formData);
      console.log("update", response);
      response && setISLoading(false);
      response.status === 200 && setLgShow(false);
      response.status === 200 && fetchAllCollectionPointDetails();
      response.status === 200 && setEdit(false);
      response.status === 200 &&
        toast.success(response.data, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
        });
    } catch (error) {
      setISLoading(false)
      console.error("Error adding Independent Engineer:", error.response?.data || error.message);

      if (error.response?.status === 400) {
        const validationErrors = error.response.data.errors || error.response.data;

        if (typeof validationErrors === "object") {
          let errorMessages = [];

          Object.keys(validationErrors).forEach((key) => {
            if (Array.isArray(validationErrors[key])) {
              validationErrors[key].forEach((msg) => {
                errorMessages.push(msg);
              });
            } else {
              errorMessages.push(validationErrors[key]);
            }
          });

          errorMessages.forEach((msg) => toast.error(msg));
          return { success: false, errors: validationErrors };
        }
      }

      // Handle general errors
      const errorMessage = error.response?.data || "Failed to add Independent Engineer";
      toast.error(errorMessage);


      return { success: false, errors: { general: errorMessage } };
    }
  };
  const handleZoneChange = (e, setFieldValue, setTouched) => {
    const newZoneId = e.target.value;
    setzoneId(newZoneId);
    setFieldValue("ZoneId", newZoneId);

    // Reset circles and wards when the zone changes
    setcircleId("");
    setAllCircles([]);
    setAllWards([]);
    setFieldValue("CircleId", "");
    setFieldValue("WardId", "");
  };
  const handleCircleChange = (e, setFieldValue, setTouched) => {
    const newCircleId = e.target.value;
    setcircleId(newCircleId);
    setFieldValue("CircleId", newCircleId);

    // Reset wards when the circle changes
    setAllWards([]);
    setFieldValue("WardId", "");
  };
  const SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
  const validationSchema = Yup.object({
    CollectionPointTypeId: Yup.string().required(
      "Collection Point Type is Required"
    ),
    CollectionPointName: Yup.string()
      .max(250, "Must be 250 characters or less")
      .required("Collection Point Name is Required"),
    CollectionPointCode: Yup.string()
      .matches(/^[A-Za-z0-9]+$/, "Only alphabets and numbers are allowed") // Allows letters and numbers
      .max(20, "Must be 20 characters or less")
      .required("Collection Point Code Required"),
    ZoneId: Yup.string().required("Zone is Required"),
    CircleId: Yup.string().required("Circle is Required"),
    ImageUrl: Yup.mixed()
    .nullable(),
    // .test("fileRequired", "Collection Point Image is Required", function (value) {
    //   return !!value;
    // })
    // .test(
    //   "fileType",
    //   "Only image file formats are supported.",
    //   function (value) {
    //     if (!value) return true;

    //     // If it's a File object
    //     if (value instanceof File) {
    //       return SUPPORTED_FORMATS.includes(value.type);
    //     }

    //     // If it's a string (URL), check extension
    //     if (typeof value === "string") {
    //       return /\.(jpe?g|png)$/i.test(value);
    //     }

    //     return false;
    //   }
    // ),
    Latitude: Yup.number().required("Latitude is required").test(
      "is-decimal",
      "Latitude must be a decimal number",
      (value) => value !== undefined && value.toString().includes(".")
    ),
    Longitude: Yup.number()
      .required("Longitude is required")
      .test(
        "is-decimal",
        "Longitude must be a decimal number",
        (value) => value !== undefined && value.toString().includes(".")
    ),
    // IsActive: Yup.boolean().required("Required"), // For the checkbox
    // Custom validation for Shifts
    ShiftA: Yup.boolean(),
    ShiftB: Yup.boolean(),
    ShiftC: Yup.boolean(),
    // atLeastOneShift: Yup.mixed().test(
    //   "at-least-one-shift",
    //   "At least one shift must be selected",
    //   function (value) {
    //     const { ShiftA, ShiftB, ShiftC } = this.parent;
    //     return ShiftA || ShiftB || ShiftC;
    //   }
    // ),
  });

  const initialValues = {
    CollectionPointId: edit ? editCollectionDetails?.collectionPointId : "",
    CollectionPointTypeId: edit
      ? editCollectionDetails?.collectionPointTypeId
      : null,
    CollectionPointTypeName: "",
    CollectionPointName: edit ? editCollectionDetails?.collectionPointName : "",
    CollectionPointCode: edit ? editCollectionDetails?.collectionPointCode : "",
    ZoneId: edit ? editCollectionDetails?.zoneId : "",
    CircleId: edit ? editCollectionDetails?.circleId : "",
    WardId: edit ? editCollectionDetails?.wardId : "",
    Latitude: (edit ? editCollectionDetails?.latitude : null) || position.lat,
    Longitude: (edit ? editCollectionDetails?.longitude : null) || position.lng,
    Remarks: edit ? editCollectionDetails?.remarks : "",
    ImageUrl: edit ? editCollectionDetails?.imageUrl : null,
    IsActive: edit ? editCollectionDetails?.isActive : true,
    ShiftA: edit ? editCollectionDetails?.shiftA : false,
    ShiftB: edit ? editCollectionDetails?.shiftB : false,
    ShiftC: edit ? editCollectionDetails?.shiftC : false,
  };

  const onSubmit = (values) => {

    if (!values.ShiftA && !values.ShiftB && !values.ShiftC) {
      values.IsActive = false;
    }

    values.CollectionPointTypeId = values.CollectionPointTypeId;
    values.CollectionPointCode = (values.CollectionPointCode);
    values.ZoneId = values.ZoneId;
    values.CircleId = values.CircleId;
    values.WardId = values.WardId;
    values.Latitude = values.Latitude;
    values.Longitude = values.Longitude;
    submitCollectionPoint(values);
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ values, setFieldValue, errors, touched, setFieldTouched, setErrors }) => (
          <Form>
            {/* ... (previous code) */}
            <div className="row">
              {/*Collection Point Type  */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Collection Point Type{" "}
                    <span style={{ color: "#EC1117" }}> *</span>{" "}
                  </label>
                  <Field
                    as="select"
                    className="form-select"
                    name="CollectionPointTypeId"
                    onChange={(e) => {
                      const selectedCollectionType = collectionPointTypes.find(
                        (collectionPointType) =>
                          collectionPointType.collectionPointTypeId === parseInt(e.target.value)
                      );

                      if (selectedCollectionType) {
                        setFieldValue("CollectionPointTypeId", selectedCollectionType.collectionPointTypeId);
                        setFieldValue("CollectionPointTypeName", selectedCollectionType.collectionPointTypeName);
                      }
                      else {
                        setFieldValue("CollectionPointTypeId", "");
                        setFieldValue("CollectionPointTypeName", "");
                      }

                      // Clear validation error when a value is selected
                      setFieldTouched("CollectionPointTypeId", false);
                    }}
                  >

                    <option value="">Select</option>
                    {collectionPointTypes.map((collectionPoint) => (
                      <option
                        value={collectionPoint.collectionPointTypeId}
                        key={collectionPoint.collectionPointTypeId}
                      >
                        {collectionPoint.collectionPointTypeName}
                      </option>

                    ))}
                    {/* <option value="">Select</option> */}
                    {/* <option value="1">GVP</option>
                    <option value="4">Sweeping Points</option> */}
                  </Field>
                  <ErrorMessage
                    name="CollectionPointTypeId"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>
              {/*Collection Point Name  */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Collection Point Name
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    type="text"
                    name="CollectionPointName"
                    placeholder="Enter Point Name"
                    className={`form-control`}
                    maxLength={42}
                  />
                  <ErrorMessage
                    name="CollectionPointName"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>
              {/*Collection Point Code  */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Collection Point Code{" "}
                    <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    type="text"
                    name="CollectionPointCode"
                    placeholder="Enter Collection Point Code"
                    className={`form-control `}
                    maxLength={8}
                  // for not accepting negitive values

                  />
                  <ErrorMessage
                    name="CollectionPointCode"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>
              {/* Zone */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Zone <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    className="form-select"
                    name="ZoneId"
                    onChange={(e) => {
                      handleZoneChange(e, setFieldValue, setFieldTouched, setErrors);
                      setFieldTouched("ZoneId", false); // Ensure validation clears
                    }}

                  >
                    <option value="">Select</option>
                    {allZones.filter((zone) => zone.isActive)
                      .map((zone) => (
                        <option value={zone.zoneId} key={zone.zoneId}>
                          {zone.zoneName}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage
                    name="ZoneId"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>

              {/* Circle */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Circle <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    as="select"
                    className="form-select"
                    name="CircleId"
                    disabled={!values.ZoneId}
                    onChange={(e) => {
                      handleCircleChange(e, setFieldValue, setFieldTouched)
                      setFieldTouched("CircleId", false)
                    }}
                  >
                    <option value="">Select</option>
                    {allCircles.filter((circle) => circle.isActive)
                      .map((circle) => (
                        <option value={circle.circleId} key={circle.circleId}>
                          {circle.circleName}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage
                    name="CircleId"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>

              {/* Ward */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">Ward</label>
                  <Field
                    as="select"
                    className="form-select"
                    name="WardId"
                    disabled={!values.CircleId}
                    onChange={(e) => {
                      setFieldValue("WardId", e.target.value);
                    }}
                  >
                    <option value="">Select</option>
                    {allWards.filter((ward) => ward.isActive)
                      .map((ward) => (
                        <option value={ward.wardId} key={ward.wardId}>
                          {ward.wardName}
                        </option>
                      ))}
                  </Field>
                </div>
              </div>

              {/* image */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label">
                    Collection Point Image
                    {/* {editCollectionDetails?"":<span style={{ color: "#EC1117" }}> *</span>} */}
                  </label>

                  <input
                    type="file"
                    name="ImageUrl"
                    className="form-control"
                    accept=".png, .jpg, .jpeg"
                    // onChange={(event) => {
                    //   setFieldValue("ImageUrl", event.currentTarget.files[0]);
                    // }}
                    onChange={(e) => {
                      handleFileChange(e, "ImageUrl");
                      setFieldValue("ImageUrl", e.currentTarget.files[0]);
                    }}
                  />

                  <ErrorMessage
                    name="ImageUrl"
                    component="div"
                    className="text-danger"
                  />
                  {values.ImageUrl && edit &&
                    editCollectionDetails?.imageUrl && (
                      <div>
                        <img
                          src={editCollectionDetails.imageUrl}
                          alt="Collection Point"
                          width="100"
                        />
                        {/* <p className="fw-bold">
                          Current image. Upload a new image to Update it.
                        </p> */}
                      </div>
                    )}
                  {(filePreviews?.fileUrl && filePreviews?.fileType !== "application/pdf" ) && (
                    <FilePreview
                      file={filePreviews.file}
                      fileType={filePreviews.fileType}
                      fileUrl={filePreviews.fileUrl}
                      width="100"
                    />
                  )}
                </div>


              </div>

              {/* Latitude */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Latitude <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    type="number"
                    name="Latitude"
                    className="form-control"
                  // value={position.lat || ""}
                  // onChange={(e) => setFieldValue("Latitude", e.target.value)}
                  />
                  <ErrorMessage
                    name="Latitude"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>
              {/* Longitude */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Longitude <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <Field
                    type="number"
                    name="Longitude"
                    className="form-control"
                  // value={position.lng || ""}
                  // onChange={(e) => setFieldValue("Longitude", e.target.value)}
                  />
                  <ErrorMessage
                    name="Longitude"
                    component="div"
                    className="text-danger"
                  />
                </div>
              </div>
              {/* Remarks */}
              <div className="col-md-12 mb-3">
                <div
                  className="form-group"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <label className="form-label">Remarks</label>
                  <Field
                    as="textarea"
                    name="Remarks"
                    rows={2}
                    maxLength={500} />
                </div>
              </div>
            </div>
            {/* radio buttons */}
            <div className="form-group" style={{ display: "flex" }}>
              <div className="form-check">
                <Field
                  type="radio"
                  name="IsActive"
                  value={true}
                  className="form-check-input"
                  checked={values.IsActive === true}
                  onChange={() => setFieldValue("IsActive", true)}
                />
                <label className="form-check-label">Active</label>
              </div>
              <div className="form-check" style={{ marginLeft: "40px" }}>
                <Field
                  type="radio"
                  name="IsActive"
                  value={false}
                  className="form-check-input"
                  checked={values.IsActive === false}
                  onChange={() => setFieldValue("IsActive", false)}
                />
                <label className="form-check-label">Inactive</label>
              </div>
            </div>

            {/* check boxes */}
            <div className="col-md-6" style={{ marginTop: "5px" }}>
              <label className="form-label">
                Shift
                {/* <span style={{ color: "#EC1117" }}> *</span> */}
              </label>
              <div className="form-group" style={{ display: "flex" }}>
                <div className="form-check">
                  <Field
                    type="checkbox"
                    name="ShiftA"
                    className="form-check-input"
                  />

                  <label className="form-check-label" htmlFor="activeRadio">
                    A
                  </label>
                </div>
                {/* shift B */}
                <div className="form-check" style={{ marginLeft: "40px" }}>
                  <Field
                    type="checkbox"
                    name="ShiftB"
                    className="form-check-input"
                    id="afternoon"
                  />

                  <label className="form-check-label" htmlFor="inactiveRadio">
                    B
                  </label>
                </div>
                {/* shift C */}
                <div className="form-check" style={{ marginLeft: "40px" }}>
                  <Field
                    type="checkbox"
                    name="ShiftC"
                    className="form-check-input"
                    id="evening"
                  />

                  <label className="form-check-label" htmlFor="inactiveRadio">
                    C
                  </label>
                </div>
              </div>
              {/* Displaying custom validation error */}
              {errors.atLeastOneShift && touched.ShiftA && (
                <div className="text-danger ">{errors.atLeastOneShift}</div>
              )}
            </div>

            {/*--- map-- */}
            <div className="col-md-12">
              <div className="form-group">
                <label className="form-label">Map</label>
                <div className="p-20">
                  <MapContainer
                    center={
                      edit && position.lat !== null
                        ? [position.lat, position.lng]
                        : [17.452555, 78.3599819]
                    }
                    zoom={13}
                    style={{ height: "300px", width: "100%" }}
                  >
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <MapEvents setFieldValue={setFieldValue} />

                    {position.lat !== null && position.lng !== null && (
                      <Marker
                        position={[position.lat, position.lng]}
                        icon={customIcon}
                      >
                        <Popup>
                          Latitude: {position.lat}, Longitude: {position.lng}
                        </Popup>
                      </Marker>
                    )}
                  </MapContainer>
                </div>
              </div>
            </div>

            {/* submit */}
            {editPermission && <div className="modal-footer d-flex justify-content-center">
              <button
                type="submit"
                className="deployment-button"
                disabled={IsLoading}
              >
                {IsLoading ? (
                  <l-metronome size="40" speed="1.8" color="red" />
                ) : (
                  <div>
                    <i className="fa-solid fa-check done-container"></i>
                    {edit ? "Update" : "Save"}
                  </div>
                )}
              </button>
            </div>}
          </Form>
        )}
      </Formik>
      {/* <ToastContainer /> */}
    </div>
  );
}

export default AddCollectionPoint;
